// Мини-задания правил B1 (тикет 06 .scratch/grammar-unify) — пишутся по урокам, частями.
import type { MiniSet } from './types'
import { MINI_B1_1 } from './b1-1'
import { MINI_B1_2 } from './b1-2'
import { MINI_B1_3 } from './b1-3'

export const MINI_B1: MiniSet[] = [...MINI_B1_1, ...MINI_B1_2, ...MINI_B1_3]
